module.exports = require('./Switch');


//////////////////
// WEBPACK FOOTER
// /Users/leedongwei/Documents/Projects/crimp-application/node_modules/rc-switch/es/index.js
// module id = 974
// module chunks = 0